import get from "lodash/get";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../tooltip";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";
import useClickOutside from "../../hooks/useClickOutside";
import { preserveScrollBeforeNavigation } from "../../utils/preserve-scroll-on-navigation";

const CycleProgram = (props) => {
  const { t } = useTranslation("coaching-portal");
  const [showOptions, setShowOptions] = useState(false);
  const [duplicating, setDuplicating] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setShowOptions(false);
    },
    showOptions
  );
  const handleOptions = (e) => {
    e.preventDefault();
    setShowOptions(!showOptions);
  };
  const {
    program,
    programIndex,
    cycle,
    athlete,
    parentPath,
    isTemplate,
    inCoachMode,
    isSubscription,
    isSubscriptionPublished,
    locals,
  } = props;

  const progressStyles = {
    "In Progress": "inprogress",
    Upcoming: "upcoming",
    Completed: "completed",
  };

  const { activeUserToRequest, activeUser, query = {} } = locals;
  const referAsClients = Boolean(activeUser.referAsClients);
  const progress = progressStyles[program.progress];

  const isPushed = program.status === "pushed" && inCoachMode;
  let previewPath = parentPath.includes("store")
    ? `/coaching-portal/store/program-preview/${cycle._id}?program=${
        programIndex + 1
      }`
    : inCoachMode || isSubscription
    ? `/coaching-portal/templates/program-preview/${cycle._id}?program=${
        programIndex + 1
      }`
    : `/dashboard/program-library/program-preview/${cycle._id}?&program=${
        programIndex + 1
      }`;

  let organizationQuery = ``;

  if (query.organizationCoach) {
    organizationQuery = `&organizationCoach=${query.organizationCoach}`;
  }

  if (athlete) {
    previewPath =
      `/athlete-portal/programs/program-preview/${cycle._id}?program=${
        programIndex + 1
      }&athlete=${athlete && athlete._id}` + organizationQuery;
  }

  const ListIcon = [
    {
      src: "/img/new-icons/duplicate.svg",
      alt: "copy",
      message: t("cycleProgram.duplicate"),
      id: "duplicate",
      url: `/actions/cycle/program/duplicate/${cycle._id}?program=${program.order}`,
      show:
        String(activeUserToRequest._id) ===
        String(get(cycle, "createdBy._id", cycle.createdBy)),

      colorClass: "icon-green",
    },
    {
      src: "/img/new-icons/eye.svg",
      alt: "view",
      message: t("cycleProgram.previewProgram"),
      id: `preview-program`,
      url: previewPath,
      show: true,
      colorClass: "icon-blue",
    },
    {
      src: "/img/new-icons/import.svg",
      alt: "send",
      message: t("cycleProgram.copyBlockTo"),
      id: `send-program-${program.order}`,
      url: `/actions/refresh/?modal[type]=send&cycleId=${cycle._id}&programOrder=${program.order}`,
      show:
        inCoachMode &&
        activeUserToRequest.athletes &&
        activeUserToRequest.athletes.length > 0,
      colorClass: "white",
    },
    {
      src: "/img/new-icons/red-trash.svg",
      alt: "delete",
      message: t("cycleProgram.deleteBlock"),
      id: "delete-program",
      url: `/actions/cycle/delete-program/${cycle._id}/${program.order}/?isFromCoachingPortal=${inCoachMode}`,
      show: program.status !== "published",
      colorClass: "icon-red",
    },
  ];

  const handleDuplicateBlock = async (e, url) => {
    e.stopPropagation();
    e.preventDefault();

    if (duplicating) return;

    setDuplicating(true);

    if (url && url.includes("?program=")) {
      const queryString = url.split("?program=")[1];
      await submit(url, {
        method: "GET",
        body: { program: queryString },
      });
    }
    setTimeout(() => {
      setDuplicating(false);
    }, 2000);
  };
  const handlePushProgram = (e) => {
    if (!isPushed)
      submit(`/actions/refresh?`, {
        method: "GET",
        body: {
          "modal[type]": "confirm-push",
          cycle: cycle._id,
          program: program.order,
        },
      });
  };
  return (
    <li className="tr-Cycle-Program-Item" data-order={programIndex}>
      <div
        className={
          !(
            (!isPushed && inCoachMode) ||
            (isSubscription && !isSubscriptionPublished) ||
            cycle.type === "user"
          )
            ? `tr-content tr-content-mobile-left`
            : `tr-content`
        }
      >
        <div className="tr-number">
          <span className={`${(progress || isPushed) && "status"}`}>
            {program.order}/{cycle.programs.length}
          </span>
        </div>
        <div className="tr-title">{program.name}</div>
      </div>
      <div className="tr-icon-group">
        {((!isPushed && inCoachMode) ||
          (isSubscription && !isSubscriptionPublished) ||
          cycle.type === "user") && (
          <a
            role="button"
            data-button-type="secondary"
            data-icon
            data-icon-only
            className="edit"
            href={
              `${parentPath}/edit-program/${cycle._id}?program=${program.order}&athlete=${query.athlete}` +
              organizationQuery
            }
          >
            <SvgIcon
              className="yellow"
              src="/img/new-icons/edit-pencil.svg"
              alt="edit"
            />
          </a>
        )}
        {/* <Dropdown /> */}
        <details ref={dropdownRef} role="list" open data-align-right>
          <summary onClick={handleOptions}>
            <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
          </summary>
          <ul role="listbox" className={showOptions ? "opened" : ""}>
            {ListIcon.map(
              ({ src, alt, id, url, message, show, colorClass }) => {
                return (
                  show && (
                    <li
                      id={`${cycle._id}${programIndex}${id}`}
                      key={`${cycle._id}${programIndex}${id}`}
                    >
                      {id === "duplicate" ? (
                        <a
                          onClick={(e) => {
                            !duplicating
                              ? handleDuplicateBlock(e, url)
                              : handleDuplicateBlock(e);
                            setShowOptions(false);
                          }}
                        >
                          <SvgIcon
                            className={
                              colorClass && !duplicating
                                ? colorClass
                                : "icon-disabled"
                            }
                            src={src}
                            alt={alt}
                          />
                          {message}
                        </a>
                      ) : (
                        <a
                          href={url}
                          onClick={() => {
                            if (
                              src === "/img/new-icons/import.svg" &&
                              isTemplate
                            ) {
                              preserveScrollBeforeNavigation();
                            }

                            setShowOptions(false);
                          }}
                        >
                          <SvgIcon
                            className={colorClass ? colorClass : ""}
                            src={src}
                            alt={alt}
                            noFilterOnLight={id === "delete-program"}
                          />
                          {message}
                        </a>
                      )}
                    </li>
                  )
                );
              }
            )}
          </ul>
        </details>
        {inCoachMode && !isTemplate && (
          <ToolTip
            className="icon-item"
            id={`${cycle._id}${programIndex}push`}
            body={
              isPushed
                ? t("cycleProgram.blockPushed")
                : referAsClients ? t("cycleProgram.pushToClient") : t("cycleProgram.pushToAthlete")
            }
          >
            <input
              type="checkbox"
              role="switch"
              checked={isPushed}
              onChange={handlePushProgram}
            />
          </ToolTip>
        )}
      </div>
    </li>
  );
};

export default CycleProgram;
